module.exports = __webpack_public_path__ + "img/ruffle back width.c644c0fc.png";